import React, { useState } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { OfferBlock } from './OfferBlock';
import { SpotsCounter } from './SpotsCounter';
import { UrgencyBar } from './UrgencyBar';
import { UpsellModal } from './UpsellModal';
import { HERO_IMAGE, HERO_IMAGE_HEIGHT, HERO_IMAGE_WIDTH } from '../data/images';
export function OrderBox() {
  const [upsellOpen, setUpsellOpen] = useState(false);
  return <div className="order-box" data-id="element-36" data-mp="2wblh9bfiosd6">
      <div className="flex flex-col items-center text-center" data-id="element-37" data-mp="2wcczzlo0mvm1">
        <img src={HERO_IMAGE} alt="The Positive Parenting Mega Kit box filled with printable routine charts" width={HERO_IMAGE_WIDTH} height={HERO_IMAGE_HEIGHT} loading="lazy" decoding="async" className="block h-auto w-full max-w-[294px]" style={{
        aspectRatio: `${HERO_IMAGE_WIDTH} / ${HERO_IMAGE_HEIGHT}`,
        filter: 'drop-shadow(0 12px 16px rgba(20,17,15,0.16))'
      }} data-id="element-38" data-mp="31aoa7xi8384s" />

        <h2 className="mt-5 text-[26px] font-extrabold leading-[1.15] md:text-[34px]" data-id="element-39" data-mp="312rvbqgi5wuj">
          <span className="block" data-id="element-40" data-mp="2w2x5lq8grdb2">The Calm Mornings</span>
          <span className="block" data-id="element-41" data-mp="2w1ca9yebrqc5">Mega Kit</span>
        </h2>

        <p className="mt-3 text-[12px] font-medium uppercase tracking-[0.14em] text-ink/55" data-id="element-42" data-mp="2s0sf30dbawsn">
          +13,369 downloads by mindful families
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-[460px]" data-id="element-43" data-mp="2i3dx2wbqpzy8">
        <OfferBlock onCheckout={() => setUpsellOpen(true)} data-id="element-44" data-mp="2i58jyg6ko24y" />
      </div>

      <div className="mt-6" data-id="element-45" data-mp="2dcp3nbgi2swg">
        <SpotsCounter data-id="element-46" data-mp="2dbdzvbn21l5c" />
      </div>

      <div className="mt-6" data-id="element-47" data-mp="28duelrrxw83w">
        <UrgencyBar data-id="element-48" data-mp="28d2vhgfj42ui" />
      </div>

      <div className="mt-4 text-center" data-id="element-49" data-mp="28e45dhkt6jan">
        <p className="flex items-center justify-center gap-1.5 text-[13px] text-ink/70" data-id="element-50" data-mp="24ciyccuygz8d">
          <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 flex-none" data-id="element-51" data-mp="1zd695lgm3g2m" />
          Instant access by email · Secure payment
        </p>
        <p className="mt-0.5 text-[12px] text-ink/55" data-id="element-52" data-mp="1uf4h4b17k6f0">
          100% digital — nothing will be shipped
        </p>
      </div>

      <UpsellModal open={upsellOpen} onClose={() => setUpsellOpen(false)} data-id="element-53" data-mp="1kp5yuzuhyuvm" />
    </div>;
}